import { render, staticRenderFns } from "./remove.vue?vue&type=template&id=44add784&"
import script from "./remove.vue?vue&type=script&lang=js&"
export * from "./remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44add784')) {
      api.createRecord('44add784', component.options)
    } else {
      api.reload('44add784', component.options)
    }
    module.hot.accept("./remove.vue?vue&type=template&id=44add784&", function () {
      api.rerender('44add784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/remove.vue"
export default component.exports